<template>
  <m-geo-box geo-option="zip" title="ZIP Code Rage">
    <b-row align-h="center">
      <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
        <h3 class="title"> Enter ZIP Code Range (5-digit) </h3>
        <div class="zip-box">
          <b-input placeholder="Enter Start ZIP Code" v-model="zipFrom" class="zip-input"></b-input>
          <span class="zip-to">to</span>
          <b-input
          placeholder="Enter End ZIP Code"
            v-model="zipTo"
            class="zip-input zip-to"
          ></b-input>
        </div>
        <b-btn @click="addZip">Add</b-btn>
      </b-col>
    </b-row>
  </m-geo-box>
</template>

<script>
import MGeoBox from "@/components/geo/MGeoBox";
import MGeoZipMenu from "@/components/geo/MGeoZipMenu";

export default {
  components: {
    MGeoBox,
    MGeoZipMenu,
  },
  data() {
    return {
      zipFrom: "",
      zipTo: "",
      a: "",
    };
  },
  computed: {
    geoType() {
      return this.$store.state.geo.geoTypes.Zip;
    },
  },
  methods: {
    validZip(zips) {
      // zips = utils.validZip(codes, type) TODO@PONY need check
      this.$http
        .post("PlaceOrder.aspx/GetZipsByZips", {
          zipType: 0,
          zips: zips,
        })
        .then((resp) => {
          // add zip to order
          let zips = resp.body.d.DataSource;
          for (let zip of zips) {
            this.$store.commit("order/addGeo", {
              GeoKeyCode: zip,
              GeoKeyDesc: zip,
              GeoType: 5,
            });
          }
        });
    },
    addZip() {
      this.$store.dispatch("order/changeGeoType", this.geoType.Code);
      this.$http
        .post("PlaceOrder.aspx/GetZipcodesByRange", {
          fromZipcode: this.zipFrom,
          toZipcode: this.zipTo,
          maxLength: 2000,
        })
        .then((resp) => {
          this.validZip(resp.body.d.DataSource);
          this.zipFrom = "";
          this.zipTo = "";
        });
    },
  },
};
</script>

<style scoped lang="scss">
.zip-input {
  width: 200px;
  display: inline-block;
}
.zip-box {
  margin-bottom: 16px;
}
.zip-to {
  margin-left: 16px;
}
.title{
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/GeoZipRange.vue